export enum FieldCategories {
  UserInput = 'UserInput',
  Calculated = 'Calculated',
  System = 'System',
  Derived = 'Derived',
}

export enum AuditActionTypes {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
}

export enum AuditValueType {
  JSON = 'Json',
  String = 'String',
}

export type AuditRecord = {
  id: string;
  moment: string;
  actionByUserName: string;
  actionByEmailAddress: string;
  actionByCompanyName: string;
  fieldDisplayName: string;
  fieldCategory: FieldCategories;
  actionType: AuditActionTypes;
  oldValue: string;
  newValue: string;
  valueType: AuditValueType;
}

export type AuditHistory = {
  applicationId: string;
  auditRecord: AuditRecord[];
}
